document.addEventListener('DOMContentLoaded', function () {
  const accordionItems = document.querySelectorAll('.product__block--collapsible_tab');

  accordionItems.forEach(function (item) {
    const panel = item.querySelector('.accordion-details__content');
    if (!panel) return;

    // Strip all HTML tags and whitespace to test for genuine content
    const text = panel.innerHTML
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/gi, '')
      .trim();

    if (text === '') {
      item.style.display = 'none';
    }
  });
});

/* ==========================================================================
   TEMPORARY — Product card, collection card + product page image normalisation
   Strips Hyper's inline --aspect-ratio as it's injected.
   Remove once all images are properly sized at upload.
   ========================================================================== */

function stripAspectRatio() {
  document.querySelectorAll(
    '.product-card__image--main, .collection-card__image, .product__media-item-container'
  ).forEach(function (el) {
    el.style.removeProperty('--aspect-ratio');
  });
}

stripAspectRatio();

const observer = new MutationObserver(stripAspectRatio);
observer.observe(document.body, {
  subtree: true,
  attributeFilter: ['style'],
  attributes: true
});